import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Modal,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { RxCross1 } from "react-icons/rx";
import { getDistributorListV2All } from "../../../../services/purchaseOrderApi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalFilterDistributor = ({
  open,
  setOpen,
  reqBody,
  setReqBody,
  isWarehouse,
}) => {
  const [tempDistArr, setTempDistArr] = useState([]);

  const handleClose = () => {
    setTempDistArr([]);
    setOpen(false);
  };

  const { data: dataDistributor, isFetching: isFetchingDistributor } = useQuery(
    {
      queryKey: ["distributor-list"],
      queryFn: () =>
        getDistributorListV2All("", isWarehouse ? isWarehouse : false),
      enabled: open === true,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setTempDistArr(reqBody.distributor_id);
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px]">Distributor</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>
          <div className="px-8 pb-4 overflow-y-auto overflow-x-hidden max-h-[40vh] ">
            {dataDistributor &&
            !isFetchingDistributor &&
            dataDistributor.data ? (
              <>
                <FormControlLabel
                  sx={{ width: "100%", marginBottom: 1 }}
                  control={<Checkbox />}
                  label="Pilih semua distributor"
                  checked={tempDistArr.length === dataDistributor.data.length}
                  onChange={(_, checked) => {
                    if (!checked) {
                      setTempDistArr([]);
                      return;
                    }
                    var temp = [...tempDistArr];
                    dataDistributor.data.map((item) => {
                      const index = tempDistArr.findIndex(
                        (id) => id === item.id
                      );

                      if (index < 0) temp = [...temp, item.id];
                    });
                    setTempDistArr(temp);
                  }}
                />
                {dataDistributor.data.map((item, i) => (
                  <FormControlLabel
                    sx={{ width: "100%", marginBottom: 1 }}
                    control={<Checkbox value={item.id} />}
                    label={item.name}
                    checked={tempDistArr.includes(item.id)}
                    onChange={() => {
                      const index = tempDistArr.findIndex(
                        (id) => id === item.id
                      );

                      setTempDistArr(
                        index < 0
                          ? [...tempDistArr, item.id]
                          : [
                              ...tempDistArr.slice(0, index),
                              ...tempDistArr.slice(index + 1),
                            ]
                      );
                    }}
                  />
                ))}
              </>
            ) : (
              <CircularProgress size={20} />
            )}
          </div>

          <div className="flex justify-end items-center px-8 py-4 gap-2">
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#F1FAF0] text-[#6F955B] border-[#6F955B] hover:bg-gray-300"
              onClick={handleClose}
            >
              Batal
            </button>
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#6F955B] border-[#6F955B] text-white hover:bg-gray-300"
              onClick={() => {
                setReqBody((prevVal) => ({
                  ...prevVal,
                  distributor_id: tempDistArr,
                  offset: 1,
                }));
                handleClose();
              }}
            >
              Simpan
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalFilterDistributor;
